export default "__VITE_ASSET__a717c9d5__"